import { API_BASE } from './core/config';

let SB_SESSION = null;
try { SB_SESSION = JSON.parse(localStorage.getItem("fb_session") || "null"); } catch (_) {}

function authHeaders() {
  const h = { "Content-Type": "application/json" };
  if (SB_SESSION?.access_token) h.Authorization = `Bearer ${SB_SESSION.access_token}`;
  return h;
}

export function setSession(s) {
  SB_SESSION = s;
  if (s?.access_token) {
    try { localStorage.setItem("fb_session", JSON.stringify(s)); } catch (_) {}
  } else {
    try { localStorage.removeItem("fb_session"); } catch (_) {}
  }
}

export async function ensureFreshToken() {
  // JWT from our API doesn't need refresh for now (7-day expiry)
  return;
}

async function apiPost(path, body) {
  const res = await fetch(`${API_BASE}${path}`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(body),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json.error || `HTTP ${res.status}`);
  return json;
}

export const sb = {
  _hasCreatedAt: ["users", "companies", "invoices", "tasks", "submissions", "payments", "tickets", "ticket_responses", "notifications", "bundles", "documents"],
  _hasUpdatedAt: ["tasks", "tickets"],

  async select(table, filter = "") {
    try {
      await ensureFreshToken();
      const rows = await apiPost("/db/select", { table, filter });
      return Array.isArray(rows) ? rows : [];
    } catch (e) {
      console.error(`❌ Select [${table}]:`, e.message);
      return [];
    }
  },

  async insert(table, data) {
    try {
      await ensureFreshToken();
      const rows = await apiPost("/db/insert", { table, data });
      console.log(`✅ Insert [${table}] OK`);
      return Array.isArray(rows) ? rows : [rows];
    } catch (e) {
      console.error(`❌ Insert [${table}] FAILED:`, e.message);
      return [];
    }
  },

  async update(table, matchKey, matchVal, data) {
    try {
      await ensureFreshToken();
      const rows = await apiPost("/db/update", { table, matchKey, matchVal, data });
      return Array.isArray(rows) ? rows : [rows];
    } catch (e) {
      console.error(`❌ Update [${table}]:`, e.message);
      return [];
    }
  },

  async upsert(table, data) {
    return this.insert(table, data);
  },

  async delete(table, filter) {
    try {
      await ensureFreshToken();
      return await apiPost("/db/delete", { table, filter });
    } catch (e) {
      console.error(`❌ Delete [${table}]:`, e.message);
      return [];
    }
  },
};

export async function createAuthFor({ email, phone, password, appUserId, name, role }) {
  try {
    const j = await apiPost("/auth/create", { email, phone, password, appUserId, name, role });
    return { ok: j.ok !== false, error: j.error || null };
  } catch (e) {
    return { ok: false, error: String(e.message || e) };
  }
}

export async function syncAuthPassword(appUserId, newPassword, { requireChangeOnNextLogin = false } = {}) {
  try {
    const j = await apiPost("/auth/set-password", { appUserId, newPassword, requireChangeOnNextLogin });
    return { ok: j.ok !== false, error: j.error || null };
  } catch (e) {
    return { ok: false, error: String(e.message || e) };
  }
}

export async function verifyPassword(identifier, password) {
  try {
    const j = await apiPost("/auth/verify-password", { identifier, password });
    return !!j.ok;
  } catch (_) {
    return false;
  }
}

export async function sendEmail(payload) {
  try {
    const res = await fetch(`${API_BASE}/email/send`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify(payload),
    });
    return res.ok;
  } catch (_) {
    return false;
  }
}

export async function sendInvoiceEmail(invoiceId, to) {
  return apiPost("/invoices/send-email", { invoiceId, to });
}
